<template>
    <!-- Pending Employees Invites Content From Employee List Component -->
    <div>
        <div class="page-header-search text-auto row no-gutters align-items-center justify-content-between">
            <div class="col search-wrapper ml-3 defaultBlue fs-15">
                <!-- <div class="breadcome-heading">
                    <div class="form-group formsearch has-warning has-feedback pull-left">
                        <input type="text" class="form-control textremove holder" id="inputWarning2" aria-describedby="inputWarning2Status" @keyup="getEmployees('pending')" v-model="searchKey" placeholder="Search...">
                        <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                    </div>
                </div> -->
                <!-- <div id="searchdigi">
                    <div id="newsearch">
                        <input type="text" @keyup="getEmployees('pending')" v-model="searchKey" placeholder="Search Employees" />
                    </div>
                </div> -->
            </div>
            <div class="col">
                <!-- <div class="switch-field hidden-sm-down  pull-right">
                    <input type="radio" id="pending-radio-one" name="pending-switch-one" value="pending-list" />
                    <label for="pending-radio-one">
                        <i class="icon-menu"></i>
                    </label>
                    <input type="radio" id="pending-radio-two" name="pending-switch-one" value="pending-grid" checked/>
                    <label for="pending-radio-two">
                        <i class="icon-tile-four"></i>
                    </label>
                </div> -->
                <div class="row no-gutters align-items-end pull-right">
                    <div class="pr-4">
                        <div class="pagination-footer">
                            <span class="page-info px-2 pt-2 fw-600" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 14px;">
                                {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}
                            </span>
                            <!-- <button type="button" class="btn btn-icon" id="previous" style="padding: 4px 1.8px 0.8rem 2px;" @click="previousPage()" :disabled="getSkipCount == 1">
                                <el-tooltip class="item" effect="dark" content="Previous" placement="top">
                                    <i class="icon icon-chevron-left" style="color: #4e5764 !important;"></i>
                                </el-tooltip>
                            </button>
                            <button type="button" class="btn btn-icon" id="next" style="padding-left:1.8px;padding-top: 4px;" @click="nextPage()">
                                <el-tooltip class="item" effect="dark" content="Next" placement="top">
                                    <i class="icon icon-chevron-right" style="color: #4e5764 !important;"></i>
                                </el-tooltip>
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                  <div class="flex-container">
                      <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                  </div>
            </div>
        </div>
        <div class="row" v-if="!ajaxCallinprogress && !employeeData.length && searchKey.length" style="justify-content: center;">
            <div class="col-lg-12 text-center py-3 px-3 mt-10">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/search.svg" class="img-fluid" style="width: 120px;">
                <h5 class="pt-3 fs-14" style="color: #00448b;">
                    Sorry We Couldn’t Find Any Matches for <span class="text-danger">"{{ this.searchKey }}"</span>
                </h5>
            </div>
        </div>
        <div class="row" v-if="!ajaxCallinprogress && !employeeData.length && !searchKey.length">
            <div class="col-lg-12 text-center py-3 px-3 mt-10">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_pending_blue.svg" class="img-fluid" style="width: 150px;">
                <h5 class="pt-3" style="color: #00448b;">No Pending Invites</h5>
            </div>
        </div>
        <div v-else class="employee-section">
            <div class="card-box employee-box" v-for="(employee, index) in employeeData" :key="index">
                <div class="md-card employee-card md-card-hover" >
                    <div class="md-card-head">
                        <div class="text-center">
                            <div class="profile-img-div border-white1">
                                <img class="md-card-head-avatar" :src="employee.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" alt="">
                            </div>
                        </div>
                        <h3 class="md-card-head-text text-center">
                            {{ employee.full_name }}
                            <span v-if="employee.email_id">
                                <el-tooltip class="item" effect="dark" :content="employee.email_id" placement="top">
                                    <span class="uk-text-truncate des-box">{{ employee.email_id }}</span>
                                </el-tooltip>
                            </span>
                            <span v-else>
                                <span class="uk-text-truncate des-box">-</span>
                            </span>
                        </h3>
                    </div>
                    <div class="md-card-content text-center" @click="changeEmployeeStatus('declined', employee._id)">
                        <button type="button" class="btn btn-greyred-outline btn-smm text-white">CANCEL</button>
                    </div>
                    <!-- <div class="md-card-content text-center" @click="changeEmployeeStatus('active', employee._id)">
                        <button type="button" class="btn btn-greyred-outline btn-smm text-white">ACCEPT</button>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <div>
            <allemployees-table></allemployees-table>
        </div> -->
    </div>
</template>
<script>
import { User } from "./mixins/user";
import { EmployeeManage } from "./mixins/employees";
import { EventBus } from "./eventBus/nav-bar-event.js";
import PendingTable from "./PendingTable";
import { HalfCircleSpinner } from 'epic-spinners'
export default {
data() {
    return {
        userSearchKey: "",
        searchKey: "",
        userSearchData: {},
        employeeData: [],
        total:0,
        ajaxCallinprogress: false,
        skip: 0,
        limit: 10,
    };
},
    components: {
        PendingTable,
        HalfCircleSpinner
    },
    mixins: [User, EmployeeManage],
    methods:{
        addEmployee() {
            this.$router.push("/addemployee");
        },
        clearSearchKey(){
            EventBus.$on('clearKey', (search_key) => {
                this.searchKey=""
                this.getEmployees("pending");
            })
        },
        // Change Status of Employee
        changeEmployeeStatus(status, id) {
        this.$http
            .post("/employees/change_employee_status", {
                status: status,
                employee_id: id,
            })
            .then(res => {
            if (res.data.status_id == 1) {
                if (status=="active"){
                    this.$awn.success("Request Accepted Successfully")
                }
                if (status=="declined"){
                    this.$awn.success("Request Rejected Successfully")
                }
                if (status=="ignore"){
                    this.$awn.success("Ignored Successfully")
                }
                if (status=="deleted"){
                    this.$awn.success("Deleted Successfully")
                }
                this.getEmployees("pending");
                //this.getUserEmployeeRequest();
            }
            else {
                this.$swal({
                    title: "Error!",
                    text: "Please try again",
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#005dae",
                });
            }
            });
        },
        nextPage() {
            let skip_temp = this.skip + this.limit > this.total? this.total: this.skip + this.limit;
            if (skip_temp >= this.total) {
                return;
            }
            this.skip = skip_temp;
            this.getEmployees("pending");
        },
        previousPage() {
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getEmployees("pending");
        },
    },
    mounted(){
        this.getEmployees("pending");
        this.clearSearchKey();
    },
    created() {
        EventBus.$on("searchemployees", searchkey => {
            this.searchKey = searchkey;
            this.getEmployees('pending');
        });
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    },
};
</script>
<style>
.disabledbtn {
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/PendingInvites.vue